import { Button, PauseIcon, PlayIcon } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import styles from './carouselPlayPause.module.css';

interface CarouselPlayPauseProps {
  /** Additional CSS class name(s) applied to the control button. */
  className?: string;

  /** True when auto-advance is paused → show the Play glyph. */
  isPaused: boolean;

  /** Toggles `BannerCarousel` auto-advance between playing and paused. */
  onToggle: () => void;
}

export const CarouselPlayPause = ({
  className,
  isPaused,
  onToggle,
}: CarouselPlayPauseProps) => {
  const Icon = isPaused ? PlayIcon : PauseIcon;

  return (
    <Button.Icon
      aria-label={isPaused ? 'Play' : 'Pause'}
      className={clsx(styles['button'], className)}
      data-testid="carousel-play-pause"
      icon={<Icon className={styles['icon']} color="grays-black" size="sm" />}
      onClick={onToggle}
    />
  );
};
